import useFormInstance from 'antd/es/form/hooks/useFormInstance'
import FormValues from '../types/form-values'

export default function useForm() {
    return useFormInstance<FormValues>()
}
